export enum FINANCIAL_REPORT_TYPE {
    FINANCIAL_REPORT_FIRST_QUARTER = 3,
    FINANCIAL_REPORT_HALF_QUARTER = 4,
    FINANCIAL_REPORT_THIRD_QUARTER = 5,
    FINANCIAL_REPORT_FULL_YEAR = 6,
    FINANCIAL_REPORT_ANNUAL = 7,
}
